import { IonPage } from '@ionic/react';

import PepperLogo from '@/assets/imgs/pepper-logo.svg';

import styles from './TermsUse.module.scss';

const TermsUse = () => (
  <IonPage>
    <div className={styles.termUse}>
      <header className={styles.termsHeader}>
        <span>
          AVISO LEGAL Y TÉRMINOS DE USO DE PEPPER COMERCIOS (v.2023.08.25)
        </span>
        <img src={PepperLogo} alt="Logo Pepper" />
      </header>
      <h1 className={styles.termsTitle}>
        AVISO LEGAL Y TÉRMINOS DE USO DE LA WEB PEPPER COMERCIOS
      </h1>
      <h2 className={styles.termsSubtitle}>¿Qué es PEPPER?</h2>
      <p>
        Pepper es la marca con la que opera la sociedad de responsabilidad
        limitada española “PEPPER FINANCE CORPORATION, S.L.U.”, provista de
        CIF/NIF nº B-86961612, y con domicilio social en la calle Juan
        Esplandiú, número 13, planta C1, C.P. 28007, Madrid (España). Inscrita
        en el Registro Mercantil de Madrid, al Tomo 32.039, Folio 211, Sección
        8ª; Hoja M- 576.566, con el fin de ofrecerte, entre otros propósitos,
        esta página web, (en adelante, “PEPPER COMERCIOS” o la “WEB”).
      </p>
      <p>
        PEPPER COMERCIOS es la solución más rápida y sencilla para gestionar
        todas tus operaciones hasta 10.000€ a golpe de clic.
      </p>
      <p>
        La WEB está pensada para facilitar el acceso al estado y el análisis
        de las operaciones de los comercios que operan con Pepper.
      </p>
      <p>
        En apenas unos segundos podrás gestionar financiaciones activas,
        aprobar nuevas, retomar operaciones, tramitar devoluciones. Además,
        puedes consultar el informe de los importes de tus operaciones,
        configurar tu perfil y formarte con los artículos y las píldoras de
        video que ponemos a tu disposición para ayudarte a sacar el máximo
        potencial a tu negocio.
      </p>
      <p>
        Pepper es un líder global en servicios financieros especializado en
        financiación inteligente y responsable. Desde su creación en Australia
        en el año 2000, la multinacional apuesta por la tecnología y el
        análisis de datos para ofrecer soluciones personalizadas a más de 2,7
        millones de clientes en 13 países: Irlanda, Reino Unido, España,
        Grecia, India, Singapur, Australia, Nueva Zelanda, Indonesia,
        Filipinas, China, Corea del Sur y Japón.
      </p>
      <p>
        Pepper impulsa a las marcas y puntos de venta online y offline a
        través de soluciones de financiación innovadoras y adaptadas a las
        necesidades de sus clientes. pepperfinance.es
      </p>
      <h2 className={styles.termsSubtitle}>TÉRMINOS DE USO DE LA WEB</h2>
      <h3 className={styles.termsSection}>1. Introducción a la WEB</h3>
      <p>
        El presente texto, (en adelante, “Aviso Legal y Términos de Uso”, o
        “Aviso Legal y Términos de Uso de PEPPER COMERCIOS”), regula la
        relación que se establece entre “PEPPER FINANCE CORPORATION, S.L.U.”,
        arriba identificada, (en adelante, “Pepper”, “Nosotros” o “nuestro”),
        y tú, (en adelante, el “Usuario”, “Tú” o “tuyo”), que contiene los
        términos y condiciones en que puedes usar PEPPER COMERCIOS, junto con
        la Política de Privacidad de PEPPER COMERCIOS.
      </p>
      <h3 className={styles.termsSection}>2. ¿Para qué sirve PEPPER COMERCIOS?</h3>
      <p>
        Como te comentábamos antes, PEPPER COMERCIOS te ofrecerá una
        experiencia de usuario única en la forma de gestionar la financiación
        que Pepper pueda conceder o haya concedido a tus clientes.
      </p>
      <p>
        Para ello, y especialmente cuando tu cliente se plantee solicitar a
        Pepper financiación para la adquisición o contratación de un bien o un
        servicio en alguno de tus establecimientos o canales de venta,
        pondremos a tu disposición desde Pepper una solución que te ayude a
        gestionar esa compra de forma sencilla, ágil y útil, y,
        posteriormente, las condiciones en que se ha verificado y se ha
        concedido la financiación por nuestra parte a dicho cliente, (en
        adelante, el “Producto”, la “Solución”, o, conjuntamente, los
        “Productos” o las “Soluciones”, contratado/s, respectivamente, por el
        cliente del Usuario de PEPPER COMERCIOS).
      </p>
      <p>
        PEPPER COMERCIOS, como comprobarás abajo, en el apartado 3.3, te
        permitirá ordenar y seguir el estado, cumplimiento, plazos y acciones
        relativas a cualquiera de los Productos o Soluciones que tus clientes
        contraten o hayan contratado a Pepper.
      </p>
      <h3 className={styles.termsSection}>3. ¿Cómo funciona PEPPER COMERCIOS?</h3>
      <p>
        3.1. Registro, acceso inicial y acceso periódico a PEPPER COMERCIOS.
      </p>
      <p>
        Inicialmente, cuando te registres por primera vez PEPPER COMERCIOS se
        producirá la aceptación de este Aviso Legal y Términos de Uso de
        PEPPER COMERCIOS junto con la Política de Privacidad de PEPPER
        COMERCIOS, sin que ello suponga, en ningún caso, la contratación de
        ningún servicio o producto adicional.
      </p>
      <p>
        Finalizado el registro, para poder acceder a PEPPER COMERCIOS deberás
        insertar el Usuario y la clave que ya dispongas como Usuario de la WEB
        de comercios o intermediarios de Pepper y aceptar expresamente el
        Aviso Legal y los Términos de Uso y la Política de Privacidad de
        PEPPER COMERCIOS, lo que te permitirá acceder a la cuenta a tu nombre
        abierta en dicha WEB de comercios o intermediarios de Pepper, (en
        adelante, la “Cuenta” o la “Cuenta de PEPPER COMERCIOS”), cuyos datos
        podrás actualizar o corregir en la sección Perfil, más abajo descrita.
      </p>
      <p>
        A partir de ese momento, en adelante, cada vez que entres en PEPPER
        COMERCIOS deberás registrarte con tu clave o Número de Identificación
        de Intermediario, -accesible medio de tu correo electrónico-.
      </p>
      <p>3.2. ¿Quién puede ser Usuario de PEPPER COMERCIOS?</p>
      <p>
        Aquellas personas físicas o personas jurídicas, (“Intermediarios”),
        que hubieran suscrito con Pepper un acuerdo dirigido a la colaboración
        entre Pepper y el Intermediario en la presentación de las soluciones y
        productos de Pepper a los clientes del Intermediario, dados de alta
        válidamente en la plataforma tecnológica de Pepper para tramitar
        operaciones de financiación a través de cualquiera de los canales
        habilitados para ello.
      </p>
      <p>
        Los Intermediarios podrán acceder a PEPPER COMERCIOS en su propio
        nombre y con su clave de Usuario, si son personas físicas, o bien por
        medio de los dependientes o representantes que designen a tal efecto,
        si son personas jurídicas, confiándoles la clave correspondiente.
        Desde Pepper esperamos que, aunque te resulte obvio, seas Tú, Usuario,
        y sólo Tú quien se registre, en virtud de una delegación correcta y
        apropiada de las claves, de las que sólo será responsable el
        Intermediario, e informes en todo momento sobre ti, Usuario, con
        veracidad. Cualquier conducta contraria se considerará conforme al
        Apartado 3.5 como un uso indebido de PEPPER COMERCIOS.
      </p>
      <p>3.3. Sección de Operaciones de PEPPER COMERCIOS.</p>
      <p>
        PEPPER COMERCIOS te permitirá acceder a una sección independiente en
        la que encontrarás una breve descripción o listado de todas las
        operaciones o Productos contratados con Pepper por tus clientes,
        retomar o continuar operaciones que estuvieran pendientes, y/o crear
        nuevas operaciones de forma sencilla (y finalizarlas bien desde PEPPER
        COMERCIOS bien a través, en su caso, del dispositivo electrónico del
        cliente), así como observar el cumplimiento, plazos y acciones
        relativas a cualquiera de los Productos que tus clientes hayan
        contratado con Pepper. Igualmente podrás cancelar totalmente o
        modificar parcialmente operaciones que estuvieran pendientes.
      </p>
      <p>
        Así, podrás consultar con facilidad los Productos contratados,
        localizándolos a través de un buscador o listado de operaciones, el
        establecimiento del Usuario o el Importe total de la Operación u
        Operaciones, entre otras funciones.
      </p>
      <p>3.4. Sección Perfil, (Perfil de Usuario de PEPPER COMERCIOS):</p>
      <p>
        Con ocasión del registro en PEPPER COMERCIOS te abriremos un perfil de
        Usuario en PEPPER COMERCIOS, (en adelante, el “Perfil”), que será una
        sección de PEPPER COMERCIOS donde encontrarás los siguientes apartados
        o sub-secciones.
      </p>
      <p>3.4.1. Sub-sección de Configuración.</p>
      <p>3.4.1.a) Notificaciones</p>
      <p>
        Tu Perfil puede recibir notificaciones de Pepper, (en adelante,
        “Notificaciones”), con diferentes propósitos, tales como descuentos,
        ofertas, nuevas campañas y nuevos Productos.
      </p>
      <p>3.4.1.b) Cambiar Clave de Acceso</p>
      <p>Podrás modificar la Clave de Acceso a tu Perfil.</p>
      <p>3.4.2. Sub-sección Contacto.</p>
      <p>
        En esta sub-sección podrás encontrar, por medio de diferentes
        apartados, los datos de contacto de Pepper, bien ya sea para dirigirte
        al Departamento Comercial, bien al de Operaciones de Pepper, con
        indicación de números de teléfono respectivos, así como, en su caso,
        datos de contacto personalizados como direcciones de correo
        electrónico.
      </p>
      <p>3.4.3. Sub-sección Preguntas Frecuentes.</p>
      <p>
        En esta sub-sección podrás encontrar una serie de respuestas a
        preguntas frecuentes genéricas por parte de los Usuarios.
      </p>
      <p>3.4.4. Sub-sección Términos y Condiciones.</p>
      <p>
        Aquí podrás encontrar el presente Aviso Legal y Términos de Uso de
        PEPPER COMERCIOS, así como la Política de Privacidad de PEPPER
        COMERCIOS en su versión más actualizada.
      </p>
      <p>3.5. Uso responsable y debido de PEPPER COMERCIOS.</p>
      <p>
        Como Usuario de PEPPER COMERCIOS, eres responsable de su uso correcto,
        en cuanto accedes a la misma o cuando ejecutas cualquiera de sus
        funcionalidades. No usas correctamente PEPPER COMERCIOS:
      </p>
      <ul className={styles.termsBreachesList}>
        <li>
          Si usas PEPPER COMERCIOS para finalidades no expuestas en este Aviso
          Legal y Términos de Uso de PEPPER COMERCIOS, ni en la Política de
          Privacidad de PEPPER COMERCIOS.
        </li>
        <li>
          Si usas PEPPER COMERCIOS de manera que vulneras los derechos de
          propiedad intelectual que de Pepper o de cualquier tercero.
        </li>
        <li>
          Si no usas PEPPER COMERCIOS aceptando y observando cualquier
          modificación del Aviso Legal y Términos de Uso de PEPPER COMERCIOS
          que propongamos, o instrucción que puedas recibir por nuestra parte
          y que hayamos considerado como parte o complemento de este Aviso
          Legal y Términos de Uso de PEPPER COMERCIOS.
        </li>
        <li>
          Si no te identificas de forma veraz, bien como Usuario persona
          física, o bien como representante legítimo para el acceso a PEPPER
          COMERCIOS de un Usuario persona jurídica.
        </li>
        <li>
          Si, con ocasión del uso de PEPPER COMERCIOS, empleas información que
          no te pertenece o que por cualquier motivo no puedes utilizar.
        </li>
        <li>
          Si, en definitiva, incumples las condiciones previstas en este Aviso
          Legal y Términos de Uso y/o de la Política de Privacidad de PEPPER
          COMERCIOS
        </li>
      </ul>
      <p>3.6. Facultades y responsabilidades de Pepper.</p>
      <p>
        3.6.1. Pepper se reserva el derecho de bloquear el uso de tu Perfil si
        lo usas indebidamente conforme al apartado anterior.
      </p>
      <p>
        3.6.2. Pepper se reserva el derecho de bloquear o restringir el acceso
        y uso de la WEB si se producen circunstancias o eventos técnicos
        ajenos a nuestra responsabilidad que así lo aconsejen, por hacer
        inviable el servicio objeto de PEPPER COMERCIOS o por reducir el mismo
        a cotas no tolerables según nuestros estándares de calidad.
      </p>
      <p>
        3.6.3. Pepper no asume responsabilidad alguna derivada de los
        contenidos, informaciones o servicios cualesquiera de las páginas web
        a las que puedas tener acceso desde PEPPER COMERCIOS tanto directa
        como indirectamente.
      </p>
      <p>
        3.6.4. Pepper no responderá de posibles daños o perjuicios derivados
        del empleo o uso que como Usuario realices de PEPPER COMERCIOS, tales
        como interferencias, interrupciones, bloqueos, virus informáticos,
        averías o desconexiones (de la red de Internet u otros),en su
        funcionamiento ni de las consecuencias del uso indebido de PEPPER
        COMERCIOS, según se indica en el apartado anterior.
      </p>
      <p>
        3.6.5. En particular, tampoco asumirá Pepper responsabilidad alguna
        por los daños o perjuicios causados por terceras personas mediante
        intromisiones ilegítimas o de forma no autorizada en la utilización y
        funcionamiento de PEPPER COMERCIOS, fruto de un uso indebido o
        ilegítimo por tu parte, entre los que se encuentra la subida a PEPPER
        COMERCIOS de contenidos que no estén previamente supervisados por
        Pepper o alguna de las sociedades de su grupo.
      </p>
      <p>3.7. Coste de la WEB.</p>
      <p>
        El coste del servicio de conexión a Internet que hayas contratado con
        tu operador de confianza será independiente a los servicios,
        utilidades y objeto de PEPPER COMERCIOS, y variará según su naturaleza
        y términos respectivos.
      </p>
      <p>El registro en la WEB y su uso son gratuitos.</p>
      <h3 className={styles.termsSection}>4. Propiedad intelectual e industrial</h3>
      <p>
        El diseño de PEPPER COMERCIOS, su software, su código fuente y sus
        códigos de programación, y todo su contenido, (incluyendo, -de forma
        enunciativa y no limitativa-, noticias, información y/o videos que
        puedan ser publicadas en cualquiera de las áreas o subáreas de PEPPER
        COMERCIOS), es propiedad de Pepper, quien ostenta los derechos de
        propiedad intelectual e industrial que son inherentes a dichos
        elementos y que, asimismo, dispone de los derechos de explotación
        pertinentes sobre los mismos. En consecuencia, queda prohibida la
        reproducción o copia, distribución y cualquier tipo de comunicación
        pública así como cualquier uso que no haya sido específicamente
        autorizado por Pepper respecto a dichos elementos.
      </p>
      <p>
        Tanto PEPPER COMERCIOS como cualquier otro elemento o contenido en la
        misma, tales como pueden ser, -de forma enunciativa y no limitativa-,
        noticias, información y/o videos que puedan ser publicadas en
        cualquiera de las áreas o subáreas de PEPPER COMERCIOS, sobre los que
        Pepper ostente derecho de propiedad intelectual o industrial o un
        derecho de explotación que así se lo permita, podrán ser actualizados,
        modificados, limitados, restringidos en sus accesos, información,
        contenidos o servicios sin previo aviso por parte de Pepper. Desde
        Pepper, podremos realizar dichas modificaciones o alteraciones de
        manera unilateral y en cualquier momento, sin asumir responsabilidad
        alguna, lo que incluye tanto el contenido como el formato de PEPPER
        COMERCIOS así como de cualesquiera de los elementos objeto de
        propiedad intelectual o industrial incluidos en PEPPER COMERCIOS.
      </p>
      <h3 className={styles.termsSection}>5. Privacidad y protección de datos.</h3>
      <p>
        Pepper recoge y trata en sus sistemas de información datos personales
        de los Usuarios de PEPPER COMERCIOS. A fin de mantener la
        confidencialidad y privacidad sobre los Datos, Pepper ha dispuesto
        medidas técnicas y organizativas para evitar alteraciones o pérdidas,
        o accesos no autorizados a ellos.
      </p>
      <p>
        Por favor, consulta la Política de Privacidad de PEPPER COMERCIOS,
        para tener más información sobre dicho tratamiento.
      </p>
      <h3 className={styles.termsSection}>
        6. Modificación del Aviso Legal y Términos de Uso de PEPPER COMERCIOS.
      </h3>
      <p>
        Cuando te registras en la WEB aceptas la versión vigente del Aviso
        Legal y Términos de Uso de PEPPER COMERCIOS, y a medida que sigas
        navegando y disfrutando de la WEB, consideraremos que aceptarás y
        ratificarás tu conformidad con la versión vigente, en dicho momento,
        del Aviso Legal y Términos de Uso de PEPPER COMERCIOS.
      </p>
      <p>
        No obstante, en caso de modificación de los Términos de Uso y de la
        Política de Privacidad PEPPER COMERCIOS solicitaremos tu
        consentimiento previo, para que continúes disfrutando de la WEB y de
        todos sus servicios y posibilidades.
      </p>
      <h3 className={styles.termsSection}>
        7. Cesión de derechos relativos al Aviso Legal y Términos de Uso de
        PEPPER COMERCIOS.
      </h3>
      <p>
        En cuanto Usuario, no puedes ceder ningún derecho u obligación con
        origen en el Aviso Legal y Términos de Uso de PEPPER COMERCIOS que
        pueda nacer o haber nacido a tu favor. Por nuestra parte, desde Pepper
        nos reservamos el derecho de ceder nuestra posición en el Aviso Legal
        y Términos de Uso de PEPPER COMERCIOS en cualquier momento, siempre
        que los derechos que, de acuerdo con la legislación aplicable, te
        acompañan no resulten perjudicados.
      </p>
      <h3 className={styles.termsSection}>8. Información y Quejas.</h3>
      <p>
        Nos tomamos muy en serio tu atención y la resolución de tus problemas,
        para lo que desde Pepper ponemos nuestras FAQs que puedes consultar en
        el apartado que lleva el mismo nombre en PEPPER COMERCIOS en tu
        Perfil.
      </p>
      <h3 className={styles.termsSection}>9. Ley aplicable.</h3>
      <p>
        La WEB se ha diseñado cumpliendo la legislación española, a la que se
        encuentra sometida.
      </p>
      <p>Atentamente, el Equipo de Pepper.</p>
      <footer>
        <p>
          © PEPPER FINANCE CORPORATION, S.L.U., Agosto 2023. Todos los
          derechos reservados.
        </p>
        <div className={styles.termsFooter}>
          “PEPPER FINANCE CORPORATION, S.L.U.”, C.I.F./N.I.F. nº B-86961612;
          calle Juan Esplandiú, nº 13, C1, C.P. 28007, Madrid, (España);
          inscrita en el Registro Mercantil de Madrid (España), al Tomo
          32.039, Folio 211, Sección 8ª, Hoja M-576.566;
          <br />
          <a className={styles.termsLink} href="https://www.pepperfinance.es">
            {' '}
            www.pepperfinance.es
          </a>
        </div>
      </footer>
    </div>
  </IonPage>
);

export default TermsUse;
